import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const ChevronRight = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 24 24"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <path
        d="M7.855 4.618a.75.75 0 0 1 1.027-.263L8.5 5l.382-.645.007.004.016.01.062.037.23.14c.196.123.475.3.81.52.668.441 1.562 1.062 2.46 1.776.894.712 1.813 1.534 2.516 2.38.68.818 1.267 1.788 1.267 2.778s-.587 1.96-1.267 2.778c-.703.846-1.622 1.668-2.516 2.38a35 35 0 0 1-3.5 2.436l-.062.038-.016.01-.006.003L8.5 19l.383.645a.75.75 0 0 1-.765-1.29m0 0 .004-.002.013-.008.055-.034.215-.132a33.326 33.326 0 0 0 3.128-2.195c.857-.682 1.687-1.431 2.296-2.165.634-.762.921-1.381.921-1.819s-.287-1.057-.92-1.82c-.61-.733-1.44-1.482-2.297-2.164A33 33 0 0 0 8.19 5.689l-.055-.033-.013-.008-.003-.002a.75.75 0 0 1-.264-1.028"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default ChevronRight;
